import http from '../plugins/axios';

export default {
  async index(client) {
    const response = await http.get(`/api/client/${client.id}/producer`)
    
    return response.data
  }
}